/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_TrolleyInputs */

const fr_vehicle_type_trolley = /** @type {(inputs: Vehicle_Type_TrolleyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trolleybus`)
};

const en_vehicle_type_trolley = /** @type {(inputs: Vehicle_Type_TrolleyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trolleybus`)
};

/**
* | output |
* | --- |
* | "Trolleybus" |
*
* @param {Vehicle_Type_TrolleyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_trolley = /** @type {((inputs?: Vehicle_Type_TrolleyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_TrolleyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_trolley(inputs)
	return en_vehicle_type_trolley(inputs)
});